import React from 'react';
import './Loader.scss';
import Lottie from 'lottie-react';
import progressAnimation from '@/assets/animation/loading.json';
export type LoaderProps = {
  text?: string;
  hideText?: boolean;
};

export const Loader = ({ hideText = false, text = 'Saving...' }: LoaderProps) => {
  return (
    <span className="loader-progress">
      <Lottie className="loader-animation" animationData={progressAnimation} />
      {hideText && <span>{text}</span>}
    </span>
  );
};
